"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotifierService = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
const Subject_1 = require("rxjs/Subject");
let NotifierService = class NotifierService {
    constructor() {
        this.defaultNotificationTitle = 'General';
        this.notifierStarted = false;
        this.emitter = new Subject_1.Subject();
    }
    start(notification) {
        if (!notification.id) {
            return new Error('Missing notification id for notification');
        }
        this.notifierStarted = true;
        return this.loadNotification(notification);
    }
    stop(notificationId, deleteNotification = false) {
        if (deleteNotification) {
            this.deleteNotification(notificationId);
        }
        else {
            //Reset the incrementalProgress fields
            this.updateNotification(notificationId, {
                incrementalProgress: false,
                loadCurrent: 0,
                loadTotal: 0,
                loadingProgress: 0
            });
        }
    }
    close(resetLoadedNotifications) {
        if (this.canCloseNotifications()) {
            this.notifierStarted = false;
            //Remove all loaded notifications
            if (resetLoadedNotifications) {
                this.loadedNotifications.length = 0;
            }
        }
    }
    switchOrganization() {
        if (this.loadedNotifications) {
            this.loadedNotifications.length = 0;
        }
        if (this.isStarted()) {
            this.notifierStarted = false;
        }
    }
    isStarted() {
        return this.notifierStarted;
    }
    startProgress(notification) {
        if (!notification.loadTotal || !notification.id) {
            return new Error(`Missing loadTotal or id to start notification progress`);
        }
        notification.incrementalProgress = true;
        notification.loadCurrent = 1;
        notification.loadingProgress = this.calculateProgress(notification.loadCurrent, notification.loadTotal);
        return this.start(notification);
    }
    progress(notification, progressCount) {
        if (!notification.status || !notification.id) {
            return new Error('Missing status or id for notification progress');
        }
        //Re enable the notifier If the notifier it's closed and there is notifications loaded
        if (!this.notifierStarted && this.getLoadedNotificationsTotal() > 0) {
            this.notifierStarted = true;
        }
        let currentNotification = this.getNotification(notification.id);
        if (currentNotification) {
            if (currentNotification.incrementalProgress) {
                notification.loadCurrent = (currentNotification.loadCurrent && !progressCount && progressCount !== 0)
                    ? currentNotification.loadCurrent + 1
                    : progressCount;
                notification.loadingProgress = this.calculateProgress(notification.loadCurrent, currentNotification.loadTotal);
                if (notification.loadCurrent >= currentNotification.loadTotal) {
                    //We are done with this notification
                    return this.stop(notification.id);
                }
            }
            this.updateNotification(notification.id, notification);
        }
        else {
            return new Error(`No notification progress has been started for notification ${notification.id}`);
        }
    }
    loadingProgress(notificationId) {
        let notification = this.getNotification(notificationId);
        return (notification)
            ? this.calculateProgress(notification.loadCurrent, notification.loadTotal)
            : 0;
    }
    calculateProgress(loadCurrent, loadTotal) {
        return (loadCurrent && loadCurrent)
            ? ((Math.round(loadCurrent * (1 / loadTotal * 100) * 100)) / 100)
            : 0;
    }
    getMessage(notificationId) {
        let notification = this.getNotification(notificationId);
        return notification ? notification.message : null;
    }
    current(notificationId) {
        let notification = this.getNotification(notificationId);
        return notification ? notification.loadCurrent : null;
    }
    total(notificationId) {
        let notification = this.getNotification(notificationId);
        return notification ? notification.loadTotal : null;
    }
    updateTotal(notificationId, newTotal) {
        let notification = this.getNotification(notificationId);
        return notification ? this.updateNotification(notificationId, { loadTotal: newTotal }) : null;
    }
    showProgress(notificationId) {
        let notification = this.getNotification(notificationId);
        return notification ? notification.incrementalProgress : null;
    }
    /**
     * Get the current loaded notification
     * @returns [ParsedNotification] return loadedValues per title [{title: 'Some Title', notifications: [{id: 1234, name: 2564}, ...]}]
     */
    getLoadedNotifications() {
        if (this.getLoadedNotificationsTotal() > 0) {
            let currentParsedIdx = -1;
            return this.loadedNotifications.reduce((parsed, loaded) => {
                currentParsedIdx = parsed.findIndex((loadedParsed) => loadedParsed && loadedParsed.title === loaded.title);
                if (currentParsedIdx === -1)
                    parsed.push({ title: loaded.title, notifications: [loaded] });
                else
                    parsed[currentParsedIdx].notifications.push(loaded);
                return parsed;
            }, []);
        }
        else {
            return [];
        }
    }
    getLoadedNotificationsTotal(filterBy) {
        if (filterBy && this.loadedNotifications) {
            return this.loadedNotifications.filter((loaded) => (loaded[filterBy.key] === filterBy.value)).length;
        }
        return this.loadedNotifications ? this.loadedNotifications.length : 0;
    }
    getAllNotifications() {
        return this.loadedNotifications || [];
    }
    //HELPERS
    loadNotification(notification) {
        if (!notification.id) { //Create random Id
            notification.id = Math.random().toString(36).substring(3);
        }
        if (!this.loadedNotifications) { //Add the first notification
            this.loadedNotifications = [notification];
            this.emitChangeEvent('load');
        }
        else { //Check if this notification already exists
            let idx = this.findNotificationIdx(notification.id);
            if (idx === -1) {
                if (!notification.title) { //Make sure we have a default title
                    notification.title = this.defaultNotificationTitle;
                }
                this.emitChangeEvent('load');
                this.loadedNotifications.push(notification);
            }
            else { //update
                this.updateNotification(notification.id, notification);
            }
        }
        this.closeContainerCheck();
        return notification;
    }
    findNotificationIdx(notificationId) {
        return this.loadedNotifications ? this.loadedNotifications.findIndex((loaded) => notificationId === loaded.id) : -1;
    }
    getNotification(notificationId) {
        if (this.getLoadedNotificationsTotal() > 0) {
            let idx = this.findNotificationIdx(notificationId);
            if (idx !== -1) {
                return this.loadedNotifications[idx];
            }
            else {
                return null;
            }
        }
        return null;
    }
    updateNotification(notificationId, fieldsToUpdate) {
        if (this.getLoadedNotificationsTotal() > 0) {
            let idx = this.findNotificationIdx(notificationId);
            if (idx !== -1) {
                let current = this.loadedNotifications[idx];
                this.loadedNotifications[idx] = Object.assign(current, fieldsToUpdate);
                this.emitChangeEvent('update');
            }
        }
    }
    deleteNotification(notificationId, deletePermanentNotification = false) {
        if (this.getLoadedNotificationsTotal() > 0) {
            let idx = this.findNotificationIdx(notificationId);
            if (idx !== -1) {
                if (!deletePermanentNotification && this.loadedNotifications[idx].preserveType === 'permanent')
                    return;
                //Remove from loaded
                let deleted = this.loadedNotifications.splice(idx, 1);
                this.emitChangeEvent('delete', deleted[0]);
                this.closeContainerCheck();
            }
        }
    }
    canCloseNotifications() {
        // only close if there is not permanent notifications loaded
        return !!this.loadedNotifications ? (this.loadedNotifications.filter(loaded => (loaded.state !== 'pending' && loaded.preserveType === 'permanent')).length === 0) : true;
    }
    closeContainerCheck() {
        // close container if there is no more 'display' notifications 
        if (this.getLoadedNotificationsTotal() === this.getLoadedNotificationsTotal({ key: 'state', value: 'pending' })) {
            this.close();
        }
    }
    emitChangeEvent(command, notification = {}) {
        //Defer emitting of event to next tick
        setTimeout(() => { this.emitter.next({ command, notification }); }, 0);
    }
};
exports.NotifierService = NotifierService;
exports.NotifierService = NotifierService = __decorate([
    (0, core_1.Injectable)()
], NotifierService);
//# sourceMappingURL=notifier.service.js.map